<template>
  <div class="container">
    <v-card
      max-width="800"
      v-if="customerData && customerData.role == 'student'"
    >
      <v-card-text>
        <h4 class="m-0 font-weight-bold text-primary">
          Сайн байна уу {{ customerData.name }} / {{ customerData.code }} /
          сурагч
        </h4>
      </v-card-text>
      <div class="card-body bg-white">
        <div class="d-flex justify-content-between">
          <div>
            <p class="mb-1">
              <span class="font-weight-bold">Нэр:</span> {{ customerData.name }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Овог:</span>
              {{ _getXXName(customerData.lastname) }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Kод:</span>
              {{ _getXXPhone(customerData.code) }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Регистрийн дугаар:</span>
              {{ _getXXRegister(customerData.register) }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Имэйл:</span>
              {{ _getXXEmail(customerData.email) }}
            </p>
            <p class="mb-1">
              <span class="font-weight-bold">Утасны дугаар:</span>
              {{ customerData.phone }}
            </p>
            <p v-if="customerData.departmentData">
              <span class="font-weight-bold">Анги: </span
              ><span class="text-primary font-weight-bold"
                >{{ customerData.departmentData.name
                }}{{ customerData.programData.name }}</span
              >
            </p>
          </div>
          <div class="col-lg-3 order-lg-2">
            <div
              class="card-profile-image"
              style="cursor: pointer"
              @click="_goToOnlineRoom(customerData)"
            >
              <a>
                <img
                  src="assets/img/onlineroom.png"
                  title="Online өрөөнд нэвтрэx"
                  width="50%"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <div
      class="container"
      v-if="customerData && customerData.role == 'teacher'"
    >
      <div v-if="userProfile.profileCompleted == true" class="container">
        <div class="card">
          <card-body style="height: 200px">
            <h3 class="pt-5 pb-2 text-center">
              Та мэдээллээ эxлээд гүйцэт бөглөнө үү.
            </h3>
            <div class="d-flex justify-content-center">
              <router-link
                :to="{
                  name: 'TeacherAdd',
                  params: {
                    teacherId: customerData.id,
                    schoolId: customerData.school.id,
                  },
                }"
                class="text-white"
              >
                <button class="btn btn-danger">Мэдээлэл бөглөx</button>
              </router-link>
            </div>
          </card-body>
        </div>
      </div>
      <div v-else class="container">
        <div class="row">
          <!-- <div class="col-auto">
              <i class="fas fa-grip-horizontal text-danger" style="font-size:20px; cursor:pointer" title="Дэлгэрэнгүй болгож xараx" v-if="showSimple" @click="showSimple=!showSimple"></i>
              <i class="fas fa-grip-lines text-danger" style="font-size:20px; cursor:pointer" title="Xураангуйлан xараx" v-else @click="showSimple=!showSimple"></i>
            </div> -->
        </div>
        <!-- for teacher -->
        <v-card class="" max-width="1000">
          <div class="card-header m-0">
            <div class="d-flex justify-content-between">
              <h3 class="m-0 font-weight-bold text-primary">
                Сайн байна уу? 
              </h3>
              <router-link
                :to="{
                  name: 'TeacherAdd',
                  params: {
                    teacherId: customerData.id,
                    schoolId: customerData.school.id,
                  },
                }"
                class="text-white"
              >
                <i
                  class="fas fa-edit text-secondary mr-2"
                  style="cursor: pointer"
                ></i>
              </router-link>
              <!-- <v-btn  v-if="customerData && customerData.role == 'teacher'" color="primary" @click="$router.push({name:'XNews', params:{schoolId: customerData.school.id}})">Мэдээ+</v-btn> -->
            </div>
          </div>

          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div>
                <p>
                  Нэр:
                  <span class="font-weight-bold">{{ customerData.name }}</span>
                </p>
                <p class="mb-1">
                  Овог:<span class="font-weight-bold">
                    {{ customerData.lastname }}</span
                  >
                </p>
                <p class="mb-1">
                  Багшийн код:<span class="font-weight-bold">
                    {{ customerData.code }}</span
                  >
                </p>
                <p class="mb-1">
                  Имэйл:<span class="font-weight-bold">
                    {{ customerData.email }}</span
                  >
                </p>
                <p>
                  <span class="font-weight-bold">Утасны дугаар: </span
                  >{{ customerData.phone }}
                </p>
              </div>
              <div class="col-lg-3" v-if="customerData">
                <div @click="_openOnlineRoom()">
                  <a>
                    <img
                      style="width: 60%"
                      v-bind:src="
                        customerData.onlineroom == null
                          ? '/assets/img/onlineroom-inactive.png'
                          : '/assets/img/onlineroom.png'
                      "
                    />
                  </a>
                </div>
              </div>
            </div>
            <div v-if="classes != null && classes.length > 0">
              <h5 class="text-primary">Удирдсан анги</h5>
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Анги</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="classObject in classes"
                      v-bind:key="classObject.id"
                    >
                      <td>
                        <span v-if="classObject.departmentData">
                          {{ classObject.departmentData.name }}/{{
                            classObject.name
                          }}
                        </span>
                      </td>
                      <td>
                        <div
                          v-if="classObject.school && classObject.department"
                        >
                          <div class="d-flex">
                            <button
                              class="btn btn-outline-primary btn-sm"
                              @click="
                                $router.push({
                                  name: 'IGroupStudents',
                                  params: {
                                    schoolId: classObject.school.id,
                                    departmentId: classObject.department.id,
                                    programId: classObject.id,
                                  },
                                })
                              "
                            >
                              Сурагчид
                            </button>
                            <button
                              class="btn btn-info btn-sm mr-2"
                              @click="_goToMyClass(classObject)"
                            >
                              Ангийн xичээлүүд
                            </button>
                            <button
                              class="btn btn-danger btn-sm mr-auto"
                              @click="goLessons(classObject)"
                            >
                              Улирлын дүн
                            </button>

                            <button
                              class="btn btn-warning btn-sm mr-2"
                              @click="_goToOnlineRoomOfClass(classObject)"
                            >
                              <i class="fa fa-video"></i> Ангийн онлайн өрөө
                            </button>
                          </div>
                          <!-- <button class="btn btn-danger btn-sm mr-2" @click="_removeClasses(classObject)">Xичээл xасаx</button> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <!-- <div class="card shadow my-4" v-if="lessons!=null && lessons.length>0">
      <div class="card-header row m-0">
        <div class="col">
          <h6 class="m-0 font-weight-bold text-primary">Миний xичээлийн ирцийн мэдээлэл</h6>
        </div>

      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-sm" id="dataTable" width="100%" cellspacing="0" >
            <thead>
              <tr>
                <th>№</th>
                <th>Анги</th>
                <th>Нэр</th>
                <th>Ирцийн мэдээлэл</th>
                <th>Төлөв</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lesson, index) in lessons" v-bind:key="lesson.id">
                <td>{{index+1}}</td>
                <td>
                  <span v-if="lesson && lesson.classNos && lesson.classNos.length>0"> {{lesson.classNos[0]}} анги</span>

                  <ul v-if="lesson.groups && lesson.groups.length>0">
                      <li style="cursor:pointer" v-for="group in lesson.groups">
                          <span v-if="group.departmentName">{{group.departmentName}}</span>
                          <span v-else>-</span>
                          /
                          <span v-if="group.programName">{{group.programName}}</span>
                          <span v-else>-</span>
                      </li>
                  </ul>
                      
                </td>
                <td>{{lesson.name}}</td>
                <td>
                  <div style="cursor: pointer;font-size:44px;" class="text-primary" >
                      <span v-if="lesson.hozroltData">**** </span>
                      <span v-else>-</span>
                  </div>
                </td>

                <td>
                  <h6 v-if="lesson.published==true" style="cursor:pointer"><span class="badge badge-success">Нээлттэй</span></h6>
                  <h6 v-else style="cursor:pointer"><span class="badge badge-danger" >Хаалттай</span></h6>
                </td>
  
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->

      <div class="container">
        <v-card max-width="1000">
          <div class="card-body bg-white">
            <div class="table-responsive">
              <div class="d-flex mb-3 justify-content-end">
                <button
                  class="btn btn-secondary btn-sm"
                  v-on:click="delete1 = true"
                  v-if="delete1 == false"
                >
                  Хуваарь цэвэрлэх
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  v-on:click="delete1 = false"
                  v-if="delete1 == true"
                >
                  Цуцлах
                </button>
              </div>
              <table class="table table-sm">
                <tr style="border: 2px solid black">
                  <th>Ээлж</th>
                  <th style="border-left: 2px solid black">
                    Цаг&nbsp;&nbsp;&nbsp;&nbsp;
                  </th>
                  <th
                    v-for="day in weekNumbers"
                    style="border-left: 1px solid black !important"
                  >
                    <span v-if="day == 1">Даваа</span>
                    <span v-if="day == 2">Мягмар</span>
                    <span v-if="day == 3">Лхагва</span>
                    <span v-if="day == 4">Пүрэв</span>
                    <span v-if="day == 5">Баасан</span>
                  </th>
                </tr>
                <tbody v-for="line in lines" style="border: 2px solid black">
                  <tr v-for="(time, index) in times">
                    <td
                      v-if="index == 0"
                      :rowspan="times.length"
                      style="vertical-align: middle"
                      class="text-primary font-weight-bold text-center"
                    >
                      {{ line }} ээлж
                    </td>
                    <td style="border-left: 2px solid black">
                      {{ time }}-р цаг
                      <span
                        class="font-weight-bold text-primary"
                        v-if="line && time"
                        ><br />{{ isIn(line + "-" + time) }}</span
                      >
                    </td>
                    <td
                      v-for="day in weekNumbers"
                      class="p-0 schedule-cell"
                      style="
                        border-left: 1px solid black !important;
                        vertical-align: middle;
                        text-align: center;
                      "
                    >
                      <div
                        v-if="
                          _getTimeObject(day, line, time) &&
                          _getTimeObject(day, line, time).length > 0
                        "
                      >
                        <div
                          v-for="p in _getTimeObject(day, line, time)"
                          class="text-primary"
                          @click="goLessonDetail(p)"
                          style="cursor: pointer"
                        >
                          <span v-if="p.programData">
                            <span v-if="p.departmentData"
                              >{{ p.departmentData.name }}/</span
                            >
                            {{ p.programData.name }}
                          </span>
                          <span
                            v-if="p.groupData"
                            class="text-primar font-weight-bold"
                          >
                            {{ splitName(p.groupData.name) }}
                          </span>
                          <span v-if="p.lessonData && !showSimple">
                            - {{ p.lessonData.name }}</span
                          >
                          <i
                            v-if="delete1 == true"
                            class="fas fa-trash text-danger text-lg ml-3"
                            style="cursor: pointer"
                            @click.stop="deleteSchedule(p)"
                          ></i>
                        </div>
                      </div>
                      <div v-else @click="askSchedule(line, time, day)">
                        &nbsp;
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div
      class="card shadow-sm mb-4 bg-white"
      v-if="customerData && customerData.role == 'admin'"
    >
      <div class="card-header py-3">
        <div class="d-flex justify-content-between">
          <h3 class="m-0 font-weight-bold text-primary">
            Сайн байна уу {{ customerData.name }} захирал?
          </h3>
          <!-- Захирал -->
          <router-link
            :to="{
              name: 'AdminManagerAddEdit',
              params: {
                adminId: customerData.id,
                schoolId: customerData.school.id,
              },
            }"
            class="text-white"
          >
            <i
              class="fas fa-edit text-secondary mr-2"
              style="cursor: pointer"
            ></i>
          </router-link>
        </div>
      </div>
      <div class="card-body bg-white">
        <p>
          <span class="font-weight-bold">Нэр:</span> {{ customerData.name }}
        </p>
        <p>
          <span class="font-weight-bold">Овог:</span>
          {{ customerData.lastname }}
        </p>
        <p>
          <span class="font-weight-bold">Имэйл:</span> {{ customerData.email }}
        </p>
        <p>
          <span class="font-weight-bold">Утасны дугаар: </span>
          {{ customerData.phone }}
        </p>
      </div>
    </div>

    <div
      class="card shadow-sm mb-4 bg-white"
      v-if="customerData && customerData.role == 'sts'"
    >
      <div class="card-header py-3">
        <div class="d-flex justify-content-between">
          <h3 class="m-0 font-weight-bold text-primary">
            Сайн байна уу {{ customerData.name }}
            {{ customerData.role }} захирал?
          </h3>
          <!-- Захирал багш -->
          <router-link
            :to="{
              name: 'AdminManagerAddEdit',
              params: {
                adminId: customerData.id,
                schoolId: customerData.school.id,
              },
            }"
            class="text-white"
          >
            <i
              class="fas fa-edit text-secondary mr-2"
              style="cursor: pointer"
            ></i>
          </router-link>
        </div>
      </div>
      <div class="card-body bg-white">
        <p>
          <span class="font-weight-bold">Нэр:</span> {{ customerData.name }}
        </p>
        <p>
          <span class="font-weight-bold">Овог:</span>
          {{ customerData.lastname }}
        </p>
        <p>
          <span class="font-weight-bold">Имэйл:</span> {{ customerData.email }}
        </p>
        <p>
          <span class="font-weight-bold">Утасны дугаар: </span>
          {{ customerData.phone }}
        </p>
      </div>
    </div>
    <div
      class="card shadow-sm mb-4 bg-white"
      v-if="customerData && customerData.role == 'manager'"
    >
      <div class="card-header py-3">
        <div class="d-flex justify-content-between">
          <h3 class="m-0 font-weight-bold text-primary">
            Сайн байна уу {{ customerData.name }} менежер?
          </h3>
          <!-- Захирал багш -->
          <router-link
            :to="{
              name: 'AdminManagerAddEdit',
              params: {
                adminId: customerData.id,
                schoolId: customerData.school.id,
              },
            }"
            class="text-white"
          >
            <i
              class="fas fa-edit text-secondary mr-2"
              style="cursor: pointer"
            ></i>
          </router-link>
        </div>
      </div>
      <div class="card-body bg-white">
        <p>
          <span class="font-weight-bold">Нэр:</span> {{ customerData.name }}
        </p>
        <p>
          <span class="font-weight-bold">Овог:</span>
          {{ customerData.lastname }}
        </p>
        <p>
          <span class="font-weight-bold">Имэйл:</span> {{ customerData.email }}
        </p>
        <p>
          <span class="font-weight-bold">Утасны дугаар: </span>
          {{ customerData.phone }}
        </p>
      </div>
    </div>
    <br />
    <div class="d-flex justify-content-between">
      <h3 class="my-10">News ({{ news.length }})</h3>
      <!-- <v-btn v-if="customerData && customerData.role == 'teacher'" color="primary" @click="_addNews">Мэдээ+</v-btn> -->


    </div>
    <hr />
    <v-row justify="start" class="mb-10" v-if="news != null && news.length > 0">
      <v-card
        v-for="(q, index) in news"
        v-bind:key="q.id"
        class="mx-10 my-12"
        max-width="374"
        min-width="400"
      >
        <v-card-title style="word-break: normal">{{ q.title }}</v-card-title>
        <v-card-text>
          <div>
            {{ getXSubStr(q.description, 100) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="customerData.id == q.userId"
            color="error lighten-2"
            text
            @click="_deleteNews(q)"
          >
            Устгаx
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="_goDetailNews(q)">
            <small>Дэлгэрэнгүй</small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>

    <!-- Modal -->
    <div
      class="modal fade"
      id="schedulModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="schedulModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="scheduleModalLabel">Хуваарь нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-center text-primary">
              {{ cweekday }} өдрийн {{ cline }} ээлжийн {{ ctime }} цаг дээр
              орох хичээлээ сонгоно уу
            </p>
            <div>
              <table class="table table-sm table-bordered">
                <tbody>
                  <tr v-for="(pro, index) in lessons" v-bind:key="index">
                    <td>
                      <div
                        @click="goAddSchedule(pro, cline, ctime, cweekday)"
                        style="cursor: pointer; font-size: 14px"
                        class="badge badge-success px-3 py-2 mr-2 my-2"
                      >
                        {{ pro.name }}
                        <span
                          v-if="pro && pro.classNos && pro.classNos.length > 0"
                        >
                          - {{ pro.classNos[0] }} анги</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="onlineRoom"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Багшийн онлайн өрөө
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="message-text" class="col-form-label"
                  >Онлайн өрөөний линк:</label
                >
                <textarea
                  class="form-control"
                  id="message-text"
                  v-model="customerData.onlineroom"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Буцаx
            </button>
            <button
              v-if="customerData.onlineroom != null"
              type="button"
              class="btn btn-secondary"
              @click="_clearOnlineRoom"
              data-dismiss="modal"
            >
              Арилгаx
            </button>
            <button
              v-if="customerData.onlineroom != null"
              type="button"
              class="btn btn-warning"
              @click="_goToOnlineRoomTeacher"
            >
              Нэвтрэx
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="_saveOnlineRoom"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="schoolModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="schoolModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="schoolModalLabel">Мэдээ нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <input
                  v-model.trim="object.title"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Гарчиг"
                />
              </div>

              <div class="form-group">
                <textarea
                  rows="10"
                  v-model.trim="object.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Тайлбар мэдээлэл"
                />
              </div>
              <div class="form-group">
                <input
                  v-model.trim="object.videoUrl"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Видео линк"
                />
              </div>

              <div class="form-group">
                <div class="">
                  <input
                    type="checkbox"
                    id="publishedCheck"
                    v-model="object.published"
                  />
                  <label for="publishedCheck"
                    >Нээлттэй<span class="text-info">
                      /Нээлттэй болгосоноор энэ мэдээллийг ажилтангууд харах
                      боломжтой./</span
                    ></label
                  >
                </div>
              </div>
              <div class="form-group">
                <div class="">
                  <input
                    type="checkbox"
                    v-model="object.forAllTeacher"
                    class="mr-2"
                  />
                  <label class="mr-4">Багш нарт</label>
                  <input
                    type="checkbox"
                    v-model="object.forAllStudent"
                    class="mr-2"
                  />
                  <label class="mr-4">Сурагчдад</label>
                  <input
                    type="checkbox"
                    v-model="object.forParent"
                    class="mr-2"
                  />
                  <label>Эцэг эx</label>
                </div>
              </div>
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="saveNews"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
 
<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import myfunction from "./global/myfunction.js";
import timetable from "./school/shared/timetable.js";
import RaddarChart from "./charts/RaddarChart";
import BarChart from "./charts/BarChart";
import axios from "axios";

export default {
  name: "Dashboard",
  components: {
    // HelloWorld,
    RaddarChart,
    BarChart,
  },
  data() {
    return {
      news: [],
      customerData: null,
      lessons: [],
      classes: [],
      lines: [1, 2],
      times: [1, 2, 3, 4, 5, 6, 7],
      weekNumbers: [1, 2, 3, 4, 5],
      pros: [],
      cline: null,
      ctime: null,
      cweekday: null,
      delete1: false,
      showSimple: true,

      object: {
        title: null,
        description: null,
        published: false,
      },
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  mixins: [timetable, myfunction],
  methods: {
    

  _addNews() {
      this.object = {};
      $("#schoolModal").modal("toggle");
    },
    saveNews() {
      console.log(this.schoolId);
      var newsPath =
        this.customerData.school.path + "/ncategories/news" + "/children";
        console.log(this.object)
      if (
        this.object != null &&
        this.object.title != null &&
        this.object.title != ""
      ) {
        if (
          this.object.videoUrl &&
          this.object.videoUrl.toLowerCase().indexOf("youtube") == -1
        ) {
          alert("Та заавал youtube бичлэг оруулна уу");
          return;
        }
        if (this.object.id != null && this.object.id != "") {
          fb.db
            .collection(newsPath)
            .doc(this.object.id)
            .update({
              title: this.object.title,
              description: this.object.description,
              published: this.object.published,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              //type: fb.db.doc(this.typePath),
              videoUrl: this.object.videoUrl ? this.object.videoUrl : null,
              // 'when': this.object.when!=undefined?this.object.when:null,
              // 'where': this.object.where!=undefined?this.object.where:null,
              // 'to': this.object.to!=undefined?this.object.to:null,
            });
        } else {
          console.log("xx");
          this.object.createdAt = new Date();
          this.object.userId = this.$store.getters.currentUser.uid;
          this.object.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          //this.object.type = fb.db.doc(this.typePath);
          // if(this.object.where!=undefined)
          //     this.object.where=null;
          // if(this.object.when!=undefined)
          //     this.object.when=null;
          // if(this.object.to!=undefined)
          //     this.object.to=null;
          console.log(newsPath)
          console.log(this.object)
          fb.db.collection(newsPath).doc().set(this.object);
        }
        this.object = {
          title: null,
          published: false,
          description: null,
          when: null,
          where: null,
          to: null,
        };
      } else {
        alert("Та гарчиг, тайлбараа оруулна уу");
      }
    },





    _goDetailNews(news) {
      var newspath =
        this.customerData.school.path + "/ncategories/news" + "/children";

      if (news.viewCount) {
        fb.db
          .collection(newspath)
          .doc(news.id)
          .update({
            viewCount: news.viewCount + 1,
          });
      } else {
        fb.db.collection(newspath).doc(news.id).update({
          viewCount: 1,
        });
      }
      this.$router.push({
        name: "XNewsDetail",
        params: {
          schoolId: this.customerData.school.id,
          newsId: news.id,
          userId: this.customerData.id,
        },
      });
    },
    _readNews() {},
    _clearOnlineRoom() {
      this.customerData.onlineroom = null;
    },
    async _goToOnlineRoomTeacher() {
      window.open(this.customerData.onlineroom, "_blank");
    },
    async _saveOnlineRoom() {
      this.customerData.ref.update({
        onlineroom: this.customerData.onlineroom.trim(),
      });
    },
    _openOnlineRoom() {
      $("#onlineRoom").modal("toggle");
    },
    _registerAccess(customerData) {
      var currentTime = null;
      axios
        .get("https://worldtimeapi.org/api/timezone/Asia/Ulaanbaatar")
        .then((response) => {
          currentTime = new Date(Date.parse(response.data.datetime));
          let clientip = response.data.client_ip;
          customerData.programRef
            .collection("onlineroomlogs")
            .doc(customerData.id)
            .collection("onlineroomlogs")
            .doc()
            .set({
              student: customerData.id,
              studentRef: customerData.ref,
              accessedDate: currentTime,
              clientip: clientip,
              dayOfYear: response.data.day_of_year,
              weekNumber: response.data.week_number,
              dayNumber: response.data.day_of_week,
            });
        });
      // console.log(customerData.ref);
      // console.log(customerData.departmentData, customerData.programData,customerData.programData.onlineroom)
    },
    _goToOnlineRoomOfClass(classObject) {
      console.log(classObject.ref.path);
      if (
        classObject.onlineroom != null &&
        classObject.onlineroom != undefined
      ) {
        window.open(classObject.onlineroom, "_blank");
        this._registerAccess(classObject.onlineroom);
      }
    },
    _goToOnlineRoom(customerData) {
      window.open(customerData.programData.onlineroom, "_blank");
      this._registerAccess(customerData);
    },
    _getData() {
      if (this.userProfile && this.userProfile.customer) {
        this.userProfile.customer.get().then(async (doc) => {
          let data = doc.data();
          data.id = doc.id;
          data.ref = doc.ref;

          if (this.userProfile.role == "student") {
            data.departmentData = null;
            data.programData = null;
            data.programplanData = null;

            if (data.department) {
              data.department.get().then((ddoc) => {
                if (ddoc.exists) {
                  data.departmentData = ddoc.data();
                }
              });
            }

            if (data.program) {
              var programDoc = await data.program.get();
              if (programDoc != null && programDoc.exists) {
                data.programData = programDoc.data();
                data.programRef = programDoc.ref;
              }
            }

            if (data.programYear) {
              data.programYear.get().then((ddoc) => {
                if (ddoc.exists) {
                  data.programplanData = ddoc.data();
                }
              });
            }
          } else {
            if (this.userProfile.role == "teacher") {
              data.departmentData = null;
              if (data.school != undefined && data.school != null)
                this._getTimeTables("/" + data.school.path + "/timetable");
              if (data.department) {
                data.department.get().then((ddoc) => {
                  if (ddoc.exists) {
                    data.departmentData = ddoc.data();
                  }
                });
              }

              fb.db
                .collectionGroup("lessonschedule")
                .where("teacher", "==", this.userProfile.customer)
                .get()
                .then((tdocs) => {
                  this.pros = [];
                  var i = 0;
                  tdocs.forEach((value) => {
                    if (value.exists) {
                      let object = value.data();
                      object.id = value.id;
                      object.ref = value.ref;
                      object.programData = null;
                      object.departmentData = null;
                      object.groupData = null;
                      object.lessonData = null;
                      object.index = i;
                      if (object.lesson) {
                        object.lesson.get().then((ldoc) => {
                          if (ldoc.exists) {
                            object.lessonData = ldoc.data();
                          }
                        });
                      }
                      if (object.program) {
                        object.program.get().then((pdoc) => {
                          if (pdoc.exists) {
                            object.programData = pdoc.data();
                            if (pdoc.ref.parent.parent) {
                              pdoc.ref.parent.parent.get().then((ddoc) => {
                                object.departmentData = ddoc.data();
                              });
                            }
                          }
                        });
                      }
                      if (object.group) {
                        object.group.get().then((pdoc) => {
                          if (pdoc.exists) {
                            object.groupData = pdoc.data();
                          }
                        });
                      }

                      this.pros.push(object);
                    }
                  });
                  i++;
                });
            }
          }
          data.role = this.userProfile.role;
          this.customerData = data;

          if (
            this.customerData &&
            this.customerData.school &&
            this.userProfile.role &&
            this.userProfile.role != "student"
          ) {
            fb.db
              .collection(
                "/schools/" + this.customerData.school.id + "/semester"
              )
              .where("default", "==", true)
              .limit(1)
              .get()
              .then((semesterSnapshot) => {
                if (!semesterSnapshot.empty) {
                  var sm = semesterSnapshot.docs[0];
                  fb.db
                    .collectionGroup("lessons")
                    .where("teacher", "==", this.userProfile.customer)
                    .get()
                    .then((querySnapshot) => {
                      if (!querySnapshot.empty) {
                        this.lessons = [];
                        querySnapshot.forEach((lessonDoc) => {
                          let lesson = lessonDoc.data();
                          lesson.id = lessonDoc.id;
                          lesson.path = lessonDoc.ref.path;
                          lesson.school = this.customerData.school;
                          lesson.hozroltData = null;
                          data.ref
                            .collection("teacher_lessons")
                            .doc(lessonDoc.id)
                            .get()
                            .then((hzDoc) => {
                              if (hzDoc.exists) {
                                lesson.hozroltData = hzDoc.data();
                              }
                            });
                          this.lessons.push(lesson);
                        });
                      }
                    });
                }
              });

            fb.db
              .collectionGroup("programs")
              .where("teacher", "==", this.userProfile.customer)
              .get()
              .then((classDocs) => {
                this.classes = [];
                classDocs.docs.forEach(async (value) => {
                  if (value && value.exists) {
                    let item = value.data();
                    item.id = value.id;
                    item.ref = value.ref;
                    item.school = this.customerData.school;
                    item.department = value.ref.parent.parent;
                    if (value.ref.parent && value.ref.parent.parent) {
                      await value.ref.parent.parent.get().then((ddoc) => {
                        item.departmentData = ddoc.data();
                      });
                    }
                    this.classes.push(item);
                  }
                });
              });
            //.where("type", "==", fb.db.doc(this.typePath))
            //.orderBy("createdAt", "desc")
          }
          var newspath =
            this.customerData.school.path + "/ncategories/news" + "/children";
 
          var roleField = "";
          if (this.customerData.role == "student") roleField = "forAllStudent";
          else if (this.customerData.role == "teacher")
            roleField = "forAllTeacher";

          fb.db
            .collection(newspath)
            .onSnapshot((querySnapshot) => {
              this.news = [];
              querySnapshot.forEach((doc) => {
                let nws = doc.data();
                nws.id = doc.id;
                nws.ref = doc.ref;
                if (nws.forAllStudent) {
                  this.news.push(nws);
                } else {
                  if (this._isThisNewsIsAllowed(nws)) 
                     this.news.push(nws);
                }
              });
            });
        });
      }
    },
    _isThisNewsIsAllowed(news, programRef) {
      for (var nn of news.userclasses) {
        if (nn.ref.path == this.customerData.programRef.path) return true;
      }
      return false;
    },
    goLessons(classObject) {
      this.$router.push({
        name: "SProgramLessons",
        params: {
          schoolId: classObject.school.id,
          departmentId: classObject.department.id,
          programId: classObject.id,
        },
      });
    },
    _goToMyClass(classObject) {
      this.$router.push({
        name: "MyClassLessons",
        params: {
          schoolId: classObject.school.id,
          departmentId: classObject.department.id,
          programId: classObject.id,
        },
      });
    },
    _removeClasses(classObject) {
      this.$router.push({
        name: "CheckClassLessons",
        params: {
          schoolId: classObject.school.id,
          departmentId: classObject.department.id,
          programId: classObject.id,
        },
      });
    },
    _getTimeObject(day, line, time) {
      var results = [];
      if (day && line && time) {
        if (this.pros && this.pros.length > 0) {
          for (const schedule of this.pros) {
            if (
              schedule &&
              schedule.day == day &&
              schedule.line == line &&
              schedule.time == time
            ) {
              results.push(schedule);
            }
          }
        }
      }
      return results;
    },
    splitName(name) {
      if (name && name.includes("/")) {
        var n = name.indexOf("/");
        return name
          .substring(n, name.length)
          .replaceAll("/", "")
          .replaceAll("-", "/");
      }
      return name;
    },
    goLessonDetail(p) {
      if (
        p &&
        p.lesson &&
        p.lesson.parent &&
        p.lesson.parent.parent &&
        this.delete1 == false
      ) {
        this.$router.push({
          name: "XILessonDetail",
          params: {
            schoolId: p.lesson.parent.parent.id,
            lessonId: p.lesson.id,
          },
        });
      }
    },
    askSchedule(line, time, wkday) {
      this.$confirm(
        "Та " +
          wkday +
          " өдрийн " +
          line +
          " ээлжийн " +
          time +
          " цаг дээр хуваарь оруулах уу?"
      ).then(() => {
        this.cline = line;
        this.ctime = time;
        this.cweekday = wkday;
        $("#schedulModal").modal("toggle");
      });
      // var r = confirm("Та "+wkday+" өдрийн "+line+" ээлжийн "+time+" цаг дээр хуваарь оруулах уу?" );
      // if (r == true) {
      //   this.cline=line;
      //   this.ctime=time;
      //   this.cweekday=wkday;
      //   $('#schedulModal').modal('toggle');
      // }
    },
    goAddSchedule(lesson, line, time, weekday) {
      $("#schedulModal").modal("toggle");
      this.$router.push({
        name: "ILessonSchedule",
        params: {
          schoolId: lesson.school.id,
          lessonId: lesson.id,
          line: line,
          time: time,
          weekday: weekday,
        },
      });
    },
    async deleteSchedule(item) {
      if (item && item.ref) {
        var r = confirm(
          "Та " +
            item.day +
            " өдрийн " +
            item.line +
            " ээлжийн " +
            item.time +
            " цаг устгах уу?"
        );
        if (r == true) {
          item.ref.delete();
          // console.log(item.index)
          // if(item.index){
          //   this.pros.splice(item.index, 1);
          // }
          this.pros = [];
          this._getData();
        }
      }
    },
  },
  created() {
    this._getData();
  },
};
</script>

<style scoped>
.schedule-cell:hover {
  /* background-color:#f0f6ff; */
  background-color: #fff3cd;
}
</style>
